import axios from "axios";

const UrlDev = process.env.REACT_APP_URl;


export const GenerateReport = async (obj: any) => {
  const apiUrl = UrlDev + "/api/pdf-data"
  const response = await axios.post(apiUrl, obj, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data
}

export const RecentPDFService = async (pageNumber: number = 1) => {
  const apiUrl = UrlDev + `/api/pdf-data?page=${pageNumber}&limit=8`
  const response = await axios.get(apiUrl, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data
}

export const DownloadPdfReport = async (id: any) => {
  const apiUrl = UrlDev + "/api/generate-pdf/" + id
  const response = await axios.get(apiUrl, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data
}

export const GetPropertyReportPdf = async (id: any, token: any) => {
  const apiUrl = UrlDev + "/api/pdf-data/" + id
  const response = await axios.get(apiUrl, {
    headers: {
      

      "Authorization": "Bearer " + token
    }
  })
  return response.data
}

export const DeleteRecentPdfService = async (id: any) => {
  const apiUrl = UrlDev + "/api/pdf-data/" + id
  const response = await axios.delete(apiUrl, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data
}